"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pbkdf2Encode;

var _pbkdf = require("pbkdf2");

var _util = require("@polkadot/util");

var _wasmCrypto = require("@polkadot/wasm-crypto");

var _asU8a = _interopRequireDefault(require("../random/asU8a"));

// Copyright 2017-2020 @polkadot/util-crypto authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
function pbkdf2Encode(passphrase, salt = (0, _asU8a.default)(), rounds = 2048) {
  const u8a = (0, _util.u8aToU8a)(passphrase);
  const password = (0, _wasmCrypto.isReady)() ? (0, _wasmCrypto.pbkdf2)(u8a, salt, rounds) : (0, _util.bufferToU8a)((0, _pbkdf.pbkdf2Sync)((0, _util.u8aToBuffer)(u8a), (0, _util.u8aToBuffer)(salt), rounds, 64));
  return {
    password,
    rounds,
    salt
  };
}